import React from "react";
import BlockyBoldText from "components/custom-texts/blocky-bold-text.tsx";
import { sparketGold, WITHDRAWAL_FEE_MODE, FeeMode } from "utils/constants.ts";
import { BothModePreviewData } from "interfaces/withdrawal-preview.ts";

export type { FeeMode };

interface FeeSettingsModalProps {
  show: boolean;
  onClose: () => void;
  feeMode: FeeMode;
  onFeeModeChange: (mode: FeeMode) => void;
  withdrawAmount: number;
  previewData?: BothModePreviewData | null;
}

const FeeSettingsModal: React.FC<FeeSettingsModalProps> = ({
  show,
  onClose,
  feeMode,
  onFeeModeChange,
  withdrawAmount,
  previewData,
}) => {
  if (!show) return null;

  const handleModeSelect = (mode: FeeMode) => {
    onFeeModeChange(mode);
    onClose();
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.95)",
        zIndex: 1050,
        display: "flex",
        alignItems: isMobile ? "flex-end" : "center",
        justifyContent: "center",
        padding: isMobile ? "0" : "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "#1a1a1a",
          borderRadius: isMobile ? "0" : "12px",
          padding: "24px",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          minWidth: isMobile ? "100%" : "300px",
          maxWidth: isMobile ? "100%" : "400px",
          borderBottom: isMobile ? "none" : "1px solid rgba(255, 255, 255, 0.1)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        
        <BlockyBoldText style={{ color: "white", marginBottom: "20px", textAlign: "center" }}>
          Fee Settings
        </BlockyBoldText>

        {/* Deduct Option */}
        <div
          onClick={() => handleModeSelect(WITHDRAWAL_FEE_MODE.DEDUCT)}
          style={{
            backgroundColor: feeMode === WITHDRAWAL_FEE_MODE.DEDUCT ? "rgba(255, 215, 0, 0.1)" : "rgba(255, 255, 255, 0.05)",
            border: feeMode === WITHDRAWAL_FEE_MODE.DEDUCT ? `2px solid ${sparketGold}` : "2px solid rgba(255, 255, 255, 0.1)",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "12px",
            cursor: "pointer",
            color: "white",
          }}
        >
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <div
              style={{
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                border: feeMode === WITHDRAWAL_FEE_MODE.DEDUCT ? `2px solid ${sparketGold}` : "2px solid rgba(255, 255, 255, 0.3)",
                backgroundColor: feeMode === WITHDRAWAL_FEE_MODE.DEDUCT ? sparketGold : "transparent",
                marginRight: "12px",
                marginTop: "2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {feeMode === WITHDRAWAL_FEE_MODE.DEDUCT && (
                <div style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "black" }} />
              )}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                Deduct fee from amount
              </div>
              <div style={{ fontSize: "0.9em", opacity: 0.8, marginBottom: "8px" }}>
                Fee is subtracted. You receive less.
              </div>
              {withdrawAmount > 0 && previewData && (
                <div style={{ fontSize: "0.85em", opacity: 0.7 }}>
                  Amount: ${withdrawAmount.toFixed(2)} → You receive: ${previewData.deduct.amount_sent_to_user.toFixed(2)}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Add Option */}
        <div
          onClick={() => handleModeSelect(WITHDRAWAL_FEE_MODE.ADD)}
          style={{
            backgroundColor: feeMode === WITHDRAWAL_FEE_MODE.ADD ? "rgba(255, 215, 0, 0.1)" : "rgba(255, 255, 255, 0.05)",
            border: feeMode === WITHDRAWAL_FEE_MODE.ADD ? `2px solid ${sparketGold}` : "2px solid rgba(255, 255, 255, 0.1)",
            borderRadius: "8px",
            padding: "16px",
            cursor: "pointer",
            color: "white",
          }}
        >
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <div
              style={{
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                border: feeMode === WITHDRAWAL_FEE_MODE.ADD ? `2px solid ${sparketGold}` : "2px solid rgba(255, 255, 255, 0.3)",
                backgroundColor: feeMode === WITHDRAWAL_FEE_MODE.ADD ? sparketGold : "transparent",
                marginRight: "12px",
                marginTop: "2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              {feeMode === WITHDRAWAL_FEE_MODE.ADD && (
                <div style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "black" }} />
              )}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                Add fee to amount
              </div>
              <div style={{ fontSize: "0.9em", opacity: 0.8, marginBottom: "8px" }}>
                Fee is added on top. You receive exact amount.
              </div>
              {withdrawAmount > 0 && previewData && (
                <div style={{ fontSize: "0.85em", opacity: 0.7 }}>
                  Total deducted from your balance: ${previewData.add.amount_deducted_from_balance.toFixed(2)} → You receive: ${previewData.add.amount_sent_to_user.toFixed(2)}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeSettingsModal;